import Input from 'src/components/Input/Input';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store';
import { setDateRangeX } from 'src/store/slices/analyticSlices';
import type { AxisGroupOption } from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsCoCustomer.types';

export const SelectDateXAxis = ({ selectOptions }: { selectOptions: AxisGroupOption[] }) => {
  const dispatch = useAppDispatch();
  const { dateX, group_by } = useAppSelector((s) => s.analyticSlices);
  const defaultValue = dateX
    ? selectOptions.find((option) => option.groupBy === group_by)
    : selectOptions[0];
  const [selectValue, setSelectValue] = React.useState(defaultValue);

  const handleDateChange = (e: AxisGroupOption) => {
    dispatch(
      setDateRangeX({
        dateX: e.groupBy,
      }),
    );
    setSelectValue(e);
  };

  useEffect(() => {
    return () => {
      dispatch(
        setDateRangeX({
          dateX: group_by,
        }),
      );
    };
  }, []);
  return (
    <div className={'input-container text-[.88rem] min-w-[140px] h-[38px] analytic-date'}>
      <Input
        type={'select'}
        selectOptions={selectOptions}
        dropdownClassName={'!py-1'}
        value={selectValue}
        // Input reports back one of selectOptions, so it is an AxisGroupOption.
        onChange={(e) => {
          handleDateChange(e as AxisGroupOption);
        }}
      />
    </div>
  );
};
